import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Config, PageNotFound404, determineShowMTrackHeader, isNativeView, removeApplicationFormAnswerState } from '@vm/omega-shared-component-webapp';
import { useRouteChange } from '../../hooks/useRouteChange';
import LandingPageContainer from '../../routes/Landing';
import ProductPageContainer from '../../routes/Product';
import { marketplaceMTrackConsentDataRequest } from '../../store/marketplace/marketplace-actions';
import { getMTrackConsentDataSelector } from '../../store/marketplace/marketplace-selectors';

const Header = React.lazy(() => import('@vm/omega-shared-component-webapp').then(({ Header }) => ({ default: Header })));
const Footer = React.lazy(() => import('@vm/omega-shared-component-webapp').then(({ Footer }) => ({ default: Footer })));
const VMApplicationContentContainer = React.lazy(() => import('@vm/omega-shared-component-webapp').then(({ StyleLibrary }) => ({ default: StyleLibrary.VMApplicationContentContainer })));

export const AppRouter: React.FC = () => {
  const { product, root } = Config.get('paths.marketplace');
  const dispatch = useDispatch();
  const mTrackConsentData = useSelector(getMTrackConsentDataSelector);
  const { ready } = mTrackConsentData;

  const { showTabNav, showUtilityNav, showHeaderNav } = determineShowMTrackHeader({ mTrackConsentData, location });

  useEffect(() => {
    dispatch(marketplaceMTrackConsentDataRequest());
  }, [dispatch]);

  useEffect(() => {
    if (isNativeView()) {
      removeApplicationFormAnswerState();
    }
  }, []);

  useRouteChange();

  return ready ? (
    <>
      <Header showTabNav={showTabNav} showUtilityNav={showUtilityNav} showHeaderNav={showHeaderNav} />
      <VMApplicationContentContainer>
        <Routes>
          <Route path={root} element={<LandingPageContainer />} />
          <Route path={product} element={<ProductPageContainer />} />
          <Route path='*' element={<PageNotFound404 mTrackConsent={showTabNav} isNativeView={isNativeView()} />} />
        </Routes>
      </VMApplicationContentContainer>
      {!isNativeView() && <Footer />}
    </>
  ) : null;
};
